// extracted by mini-css-extract-plugin
export default {"gameControls":"GameControls_gameControls__qSrsV","balanceContainer":"GameControls_balanceContainer__wsVRD","bold":"GameControls_bold__RW-5p","wrapper":"GameControls_wrapper__mTi7N"};